import { useState, useMemo, useEffect } from 'react';
import i18n from 'i18next';
import { Select } from 'antd';
import { updateTranslations } from '@/i18n';
import { PLATFORM_NAME } from '@/constants';
import LocalSvg from '@/assets/local.svg';
import { useLocation } from 'react-router-dom';
import { useValidateUser } from './useValidateUser';

const EXCLUDE_I18N = ['17track', 'treet', 'dhgate', 'garmentory'];

// 判断是否是 `/` 或以某一项的根路径开头
const isRootOrPlatformRoot = (path) => {
  if (path === '/') {
    return true; // 是根路径
  }
  // 检查是否以 PLATFORM_NAME 中的某一项作为根路径
  return Object.values(PLATFORM_NAME).some((platform) => path === `/${platform}`);
};

export const useLanguage = () => {
  const location = useLocation();
  const { isValidUser } = useValidateUser();
  const currentPath = location.pathname; // 获取路径名

  // 判断路径中是否包含 EXCLUDE_I18N 中的任何一项
  const hasExcludedPath = EXCLUDE_I18N.some((item) => currentPath.includes(item));

  useEffect(
    () => {
      if (hasExcludedPath) {
        updateTranslations('en-US');
      }
    },
    [hasExcludedPath],
  );

  // 定义语言
  const [language, setLanguage] = useState(i18n.language || localStorage.getItem('i18nextLng') || navigator.language || 'en-US'); // 默认语言为英文
  // 定义语言选项
  const [languageList] = useState([
    {
      code: 'en-US',
      name: 'English',
    },
    {
      code: 'es-ES',
      name: 'Español',
    },
    {
      code: 'pl-PL',
      name: 'Polski',
    },
    {
      code: 'pt-PT',
      name: 'Português',
    },
    {
      code: 'it-IT',
      name: 'Italiano',
    },
    {
      code: 'de-DE',
      name: 'Deutsch',
    },
    {
      code: 'cs-CZ',
      name: 'Čeština',
    },
    {
      code: 'fr-FR',
      name: 'Français',
    },
    {
      code: 'nl-NL',
      name: 'Nederlands',
    },
  ]);

  // 切换语言
  const handleChangeLanguage = (value) => {
    setLanguage(value);
    updateTranslations(value);
  };

  useEffect(() => {
    if (i18n.language !== language) {
      setLanguage(i18n.language);
    }
  }, [i18n.language]);

  const langSelectCom = useMemo(
    () => (
      !hasExcludedPath && (isValidUser || isRootOrPlatformRoot(currentPath)) && (
        <Select className="relative" onChange={handleChangeLanguage} prefix={<img style={{ marginTop: '5px' }} alt="local" src={LocalSvg} />} style={{ width: '140px' }} value={language}>
          {languageList?.map((item) => (
            <Select.Option key={item.code} value={item.code}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      )
    ),
    [language, languageList, hasExcludedPath, isValidUser, currentPath],
  );

  return {
    language, languageList, langSelectCom,
  };
};
